import { Ass_01, Exp_01 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const HOME_OFFICE_UTILITIES: Template = {
  id: "41af3a9d-087a-4aa3-be3d-d7c15e9925cd",
  name: "Kodukontori kulude kompensatsioon kassast",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Title",
      value: "Kodukontori kulud (30%)"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Kodukontori kulude kompensatsioon (30%)",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Exp_01,
          credit: Ass_01
        }
      ]
    };

    return { type: "success", entry };
  }
};
